import { bookingKeys } from "./query_keys";

export const bookingMutationsKeys = {
  multiple: () => [...bookingKeys.all(), "update"],
  create: () => [...bookingKeys.all(), "create"],
  update: (id: number) => [...bookingKeys.single(id), "update"],
  delete: (id: number) => [...bookingKeys.single(id), "delete"],
  replaceRange: () => [...bookingKeys.all(), "replaceRange"]
};
